export default class Usuario {
  constructor(email, nivel, token) {
    this.email = email;
    this.nivel = nivel;
    this.token = token;
  }
}
